import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import { FormatError } from '../../services/error';

import './ErrorComponent.scss';

const ErrorComponent = ({ title, error, style }) => {
  const makeLineKey = (iLine) => {
    return `${iLine}`;
  };
  const message = FormatError(error);
  return (
    <div className="grb-error-ctnr" style={style}>
      <div className="grb-error-title">
        <ErrorIcon style={{ fontSize: 60 }} />
        <Typography variant="h6">{title}</Typography>
      </div>
      <div className="grb-error-message">
        {message.split('\n').map((line, iLine) => (
          <Typography key={makeLineKey(iLine)} variant="body1">{line}</Typography>
        ))}
      </div>
    </div>
  );
};

ErrorComponent.propTypes = {
  title: PropTypes.string.isRequired,
  error: PropTypes.shape({}).isRequired,
  style: PropTypes.shape({}),
};

ErrorComponent.defaultProps = {
  style: undefined,
};

export default ErrorComponent;
